/**
 * Shared styling constants for post and reply cards
 * Used across thread pages and My Posts page to maintain consistency
 */

export const replyCardStyles = {
  container: "rounded-[10px] border border-[rgba(255,62,165,0.24)] px-3 py-2.5 transition-all duration-300",
  background: "linear-gradient(135deg, rgba(255, 62, 165, 0.18), transparent 18%), #111118",
  backgroundHighlighted: "linear-gradient(135deg, rgba(255, 62, 165, 0.35), rgba(255, 62, 165, 0.15) 25%, transparent 40%), #111118",
  borderColor: "rgba(255, 62, 165, 0.24)",
  borderColorHighlighted: "rgba(255, 62, 165, 0.5)",
  shadowHighlighted: "0 0 20px rgba(255, 62, 165, 0.3)",
  headerMargin: "mb-2",
  pseudonym: "text-[15px] font-semibold",
  timestamp: "text-[11px] text-[#a3a3c2]",
  audioPlayerContainer: "mb-2 rounded-[14px] border border-[#262636] bg-[#151522] px-3 py-2.5",
};

export const postCardStyles = {
  container: "rounded-[18px] border border-[rgba(255,255,255,0.02)] px-4 pb-5 pt-4 shadow-[0_18px_45px_rgba(0,0,0,0.6)] transition-[border-color,background] duration-300",
  background: "linear-gradient(to bottom right, #171727, #111118, #171727)",
  backgroundHighlighted: "linear-gradient(135deg, rgba(255, 62, 165, 0.35), rgba(255, 62, 165, 0.15) 25%, transparent 40%), linear-gradient(to bottom right, #171727, #111118, #171727)",
  borderColorHighlighted: "rgba(255, 62, 165, 0.5)",
  shadowHighlighted: "0_0_20px_rgba(255,62,165,0.3)",
  headerMargin: "mb-2.5",
  pseudonym: "text-[15px] font-semibold",
  timestamp: "text-xs text-[#707090]",
  audioPlayerContainer: "mb-2.5 rounded-[14px] border border-[#262636] bg-[#151522] px-3 py-2.5",
  successMessage: "mb-2.5 rounded-[12px] border border-green-500/30 bg-green-500/10 px-3 py-2 text-sm text-green-400 transition-opacity duration-300",
  errorMessage: "mb-2.5 rounded-[12px] border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-400",
};
